// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__BvYpm > div:first-child {
  display: flex;
  justify-content: space-between; }
  .styles_container__BvYpm > div:first-child .styles_headerChildren__duCGL {
    margin: 0rem 2rem;
    display: flex;
    align-items: center; }
    .styles_container__BvYpm > div:first-child .styles_headerChildren__duCGL button {
      margin: 0rem 1rem; }
    .styles_container__BvYpm > div:first-child .styles_headerChildren__duCGL .styles_options__0tF8X button {
      flex-direction: row-reverse; }
    .styles_container__BvYpm > div:first-child .styles_headerChildren__duCGL .styles_options__0tF8X svg {
      margin: 0rem 1rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/shelter/components/Screen/styles.module.scss"],"names":[],"mappings":"AAAA;EAEI,aAAa;EACb,8BAA8B,EAAA;EAHlC;IAMM,iBAAiB;IACjB,aAAa;IACb,mBAAmB,EAAA;IARzB;MAUQ,iBAAiB,EAAA;IAVzB;MAcU,2BAA2B,EAAA;IAdrC;MAiBU,iBAAiB,EAAA","sourcesContent":[".container {\n  & > div:first-child {\n    display: flex;\n    justify-content: space-between;\n    //   position: fixed;\n    .headerChildren {\n      margin: 0rem 2rem;\n      display: flex;\n      align-items: center;\n      button {\n        margin: 0rem 1rem;\n      }\n      .options {\n        button {\n          flex-direction: row-reverse;\n        }\n        svg {\n          margin: 0rem 1rem;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__BvYpm`,
	"headerChildren": `styles_headerChildren__duCGL`,
	"options": `styles_options__0tF8X`
};
export default ___CSS_LOADER_EXPORT___;
